import { ActionsColumn, TABLE_ACTION, TABLE_ACTION_STATE } from '@qrios/frontend-library';

import { SmsBillingResponseItem, SmsBillingTableData, SmsBillingTableRowActions } from './interfaces';

export const mapApiDataIntoTableFormat = (
  data: SmsBillingResponseItem[],
  actionsHandling: SmsBillingTableRowActions
): SmsBillingTableData[] =>
  data.map((ussdBillingItem: SmsBillingResponseItem) => {
    const { cost, id, ...rest } = ussdBillingItem;

    const actions = [
      {
        name: TABLE_ACTION.INFO,
        state: TABLE_ACTION_STATE.ACTIVE,
        handler: () => {
          actionsHandling.openDetails(id);
        }
      }
    ];

    return {
      ...rest,
      id,
      cost: cost.value,
      actions: <ActionsColumn actions={actions} />
    };
  });
